import React from 'react';
import { Card, Typography } from 'antd';

const { Title, Paragraph, Text } = Typography;

interface PlaceholderPageProps {
  title: string;
  summary: string;
  designSection: string;
}

const PlaceholderPage: React.FC<PlaceholderPageProps> = ({ title, summary, designSection }) => (
  <Card>
    <Title level={3} style={{ marginTop: 0 }}>
      {title}
    </Title>
    <Paragraph type="secondary">{summary}</Paragraph>
    <Paragraph>
      本期为框架脚手架占位页，业务能力见后续任务。产品规则：
      <Text code>kfy-system-design/kfy-design-kac.md</Text>
      {designSection ? <>（{designSection}）</> : null}
    </Paragraph>
  </Card>
);

export default PlaceholderPage;
